import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_filing_hdr_RowClass} from '../../../dbschema/bl_fi_filing_hdr.model';

export class FinancialFilingContainerModel extends BaseContainerModel {
  bl_fi_filing_hdr: bl_fi_filing_hdr_RowClass = new bl_fi_filing_hdr_RowClass();
}
